import { Text } from '@kanda-libs/ks-design-library';

import JobQuoteItemCustom from './JobQuoteItemCustom';
import JobQuoteItemKanda from './JobQuoteItemKanda';
import useJobQuoteBreakdown from './useJobQuoteBreakdown';

const JobQuoteBreakdown: React.FunctionComponent = function () {
  const {
    lineItems,
    isLoading,
    bodyClassName,
    headingClassName,
    gridClassName,
    compact,
  } = useJobQuoteBreakdown();
  return (
    <div className={bodyClassName}>
      <Text
        className={headingClassName}
        text="Quote breakdown"
        isLoading={isLoading}
        skeletonProps={{
          width: 150,
        }}
      />
      <div className={gridClassName}>
        {!lineItems ? (
          <div />
        ) : (
          lineItems.map((lineItem, index) => {
            if (lineItem.type === 'custom')
              return (
                <JobQuoteItemCustom
                  key={lineItem.title}
                  index={index}
                  isLoading={isLoading}
                  compact={compact}
                  {...lineItem}
                />
              );
            return (
              <JobQuoteItemKanda
                key={lineItem.title}
                index={index}
                isLoading={isLoading}
                compact={compact}
                {...lineItem}
              />
            );
          })
        )}
      </div>
    </div>
  );
};

export default JobQuoteBreakdown;
